import React, { useState } from "react";
import SimulationScheduleAPI from "../services/SimulationScheduleAPI";
import "./css/CreateSimulationSchedule.css";

function CreateSimulationSchedule() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");

    try {
      console.log(
        "Triggering backend schedule creation (like EventBridge Lambda)..."
      );

      // Call backend without any parameters - let backend handle all logic
      const response = await SimulationScheduleAPI.createSchedule();

      console.log("Backend schedule creation response:", response);

      if (response && response.success) {
        setMessage(
          `Successfully triggered schedule creation! ` +
            `Backend created ${response.schedulesCreated || 0} schedules for ${
              response.usersProcessed || 0
            } users.`
        );
      } else {
        setMessage(
          `Schedule creation completed with message: ${
            response?.message || "Unknown response"
          }`
        );
      }
    } catch (error) {
      console.error("Error triggering schedule creation:", error);
      setMessage(
        `Error: ${error.message || "Failed to trigger schedule creation"}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-simulation-schedule">
      <h2>Trigger Simulation Schedule Creation</h2>

      <div className="description">
        <p>
          This function simulates an EventBridge Lambda trigger that creates
          simulation schedules for all users based on their profiles and
          settings.
        </p>
        <p>
          The backend will automatically determine which users need schedules,
          their frequencies, and create the appropriate schedule entries.
        </p>
      </div>

      {message && (
        <div
          className={`message ${
            message.includes("Error") ? "error" : "success"
          }`}
        >
          {message}
        </div>
      )}

      <div className="form-actions">
        <button
          type="button"
          className="btn-primary trigger-button"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Creating Schedules..." : "Trigger Schedule Creation"}
        </button>
      </div>
    </div>
  );
}

export default CreateSimulationSchedule;
